import React, { useState } from "react";
import {
  Button,
  Select,
  Collapse,
  Form,
  Tabs,
  Popover,
  DatePicker,
  Radio,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import { loadComparisonDateData } from "../../appRedux/actions/Reports";
import IntlMessages from "../../util/IntlMessages";
import moment from "moment";
import { isEmptyObject } from "../../appRedux/actions";

const RadioGroup = Radio.Group;
const ComparisonDateSelectFilter = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  //#region useState
  const [getComparisonValue, setComparisonValue] = React.useState(0); //Its mean - Its mean no comparison
  const [getComparisonDateJson, setComparisonDateJson] = useState({});
  const [getIsDateComparisonPopoverVisible, setIsDateComparisonPopoverVisible] =
    useState(false);
  const [getDisplayDate, setDisplayDate] = useState("");
  const [getSameDatePreviousYear, setSameDatePreviousYear] = useState("");

  //#endregion useState

  //#region Use Selector Start Region
  const getReduxComparisonDateData = useSelector(
    ({ Reports }) => Reports.comparisonDateData
  );
  const getReduxCalculated = useSelector(
    ({ Reports }) => Reports.getCalculatedComparison
  );

  const getReduxSpecifiedDateRangeData = useSelector(
    ({ Reports }) => Reports.specifiedDateRangeData
  );
  //#endregion Use Selector End Region

  //#region for Use Effect Start Region
  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     CalculateComparisonSelectedDate(getComparisonValue, true);
  //     let sameDatePrevYear = CalculateSameDateInPreviousYear();
  //     setSameDatePreviousYear(sameDatePrevYear);
  //     return () => (mounted = false);
  //   }
  // }, []);

  //how to use
  // React.useEffect(() => {
  //   let mounted = true;

  //   if (mounted) {
  //     let jsonData = getReduxComparisonDateData;
  //     let displayComparisonData =
  //       getReduxComparisonDateData && getReduxComparisonDateData != undefined
  //         ? getReduxComparisonDateData.DisplayComparisonTypeDate
  //         : "";
  //     setDisplayDate(displayComparisonData);
  //     return () => (mounted = false);
  //   }
  // }, [getReduxComparisonDateData]);

  // React.useEffect(() => {
  //   let mounted = true;

  //   if (mounted) {

  //     setDisplayDate(displayComparisonData);
  //     return () => (mounted = false);
  //   }
  // }, [getReduxCalculated]);
  //#endregion for Use Effect End Region

  //#region Api Services
  //#endregion Api Services

  //#region onChange Functions
  //#region UseEffect
  React.useEffect(() => {
    let mounted = true;

    if (mounted) {
      let jsonData = getReduxSpecifiedDateRangeData;
      let fromDate = moment().format("YYYY-MM-DD");
      let toDate = moment().format("YYYY-MM-DD");
      let displayDate = `${fromDate} ${toDate}`;
      let dateRangeObject =
        getReduxSpecifiedDateRangeData &&
        getReduxSpecifiedDateRangeData != undefined
          ? getReduxSpecifiedDateRangeData.IsSpecificPeriod == true
            ? getReduxSpecifiedDateRangeData.SpecificPeriodDates
            : getReduxSpecifiedDateRangeData.SpecificDatesRange
            ? getReduxSpecifiedDateRangeData.SpecificPeriodDates.DisplayDate
            : ""
          : "";
      //Here We Minus 1 Year on Dates
      if (dateRangeObject != "") {
        fromDate =
          dateRangeObject && dateRangeObject.FromDate
            ? moment(moment(dateRangeObject.FromDate, "YYYY-MM-DD"))
                .subtract(1, "years")
                .format("YYYY-MM-DD")
            : fromDate;
        toDate =
          dateRangeObject && dateRangeObject.ToDate
            ? moment(moment(dateRangeObject.ToDate, "YYYY-MM-DD"))
                .subtract(1, "years")
                .format("YYYY-MM-DD")
            : toDate;
        displayDate = `${fromDate} ${toDate}`;
      }
      setDisplayDate(displayDate);
      return () => (mounted = false);
    }
  }, [getReduxSpecifiedDateRangeData]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!isNaN(getReduxComparisonDateData)) {
        setComparisonValue(getReduxComparisonDateData);
      } else {
        setComparisonValue(0);
      }

      return () => (mounted = false);
    }
  }, [getReduxComparisonDateData]);
  //#endregion

  const handleChangeRadioComparison = (e) => {
    setComparisonValue(e.target.value);
    // let comparisonValue = e.target.value; //old
    // CalculateComparisonSelectedDate(comparisonValue);//old
  };

  const handleClickDateApply = () => {
    setIsDateComparisonPopoverVisible(false);
    dispatch(loadComparisonDateData(getComparisonValue)); //new
    // dispatch(loadComparisonDateData(getComparisonDateJson));//old
    //set redux value here
  };

  //#endregion onChange Functions

  //#region Calculated Functions

  // function CalculateSameDateInPreviousYear() {
  //   let previousyearDate = "22 Nov 2020 to 15 Dec 2020";
  //   return previousyearDate;
  // }

  // const CalculateComparisonSelectedDate = (comparisonPropsValue, isRedux) => {
  //   let comparisonValue = comparisonPropsValue; //No Comparion ,etc.....
  //   let displayDate =
  //     moment().startOf("year").format("YYYY-MM-DD") +
  //     " to " +
  //     moment().format("YYYY-MM-DD"); //  "1st Jan 2021–17th Nov 2021";
  //   let comparisonType = "no_comparison";
  //   let displayComparisonDate = "";
  //   let fromDate = "";
  //   let toDate = "";
  //   if (comparisonValue == 1) {
  //     //no_comparison
  //     comparisonType = "no_comparison";
  //     displayComparisonDate = "No Comparison";
  //   } else if (comparisonValue == 2) {
  //     //same_date
  //     displayComparisonDate = CalculateSameDateInPreviousYear();
  //     fromDate = "22 Nov 2020";
  //     toDate = "15 Dec 2020";
  //   } else if (comparisonValue == 3) {
  //     //same_period
  //     displayComparisonDate = "23 Nov 2020 to 16 Dec 2020";
  //     fromDate = "23 Nov 2020";
  //     toDate = "16 Dec 2020";
  //   }
  //   let isReduxSet = isRedux != undefined ? isRedux : false;

  //   const ComparisonDateJson = {
  //     ComparisonValue: comparisonValue,
  //     ComparisonDateType: comparisonType,
  //     FromDate: fromDate,
  //     ToDate: toDate,
  //     DisplayComparisonTypeDate: displayComparisonDate, // Idhar Date bhe aasakti hy ,,fromDate-toDate,,
  //   };

  //   setComparisonDateJson(ComparisonDateJson);
  //   if (isReduxSet) {
  //     dispatch(loadComparisonDateData(ComparisonDateJson));
  //   }
  // };
  //#endregion

  const CalculateComparisonSelectedDate = (comparisonPropsValue, isRedux) => {
    let comparisonValue = false;
    let comparisonType = "";
    let fromDate = "";
    let toDate = "";
    let displayComparisonDate = "";
    const data = getReduxCalculated;
    if (!isEmptyObject(data)) {
      if (comparisonPropsValue == 1) {
        comparisonValue = true;
        comparisonType = "yearly";
        fromDate = data.subFrom ? data.subFrom : "";
        toDate = data.subTo ? data.subTo : "";
      } else if (comparisonPropsValue == 2) {
        comparisonValue = true;
        comparisonType = "periodly";
        fromDate = data.periodFrom ? data.periodFrom : "";
        toDate = data.periodTo ? data.periodTo : "";
      }
      displayComparisonDate =
        comparisonPropsValue == 2 || comparisonPropsValue == 3
          ? `${fromDate} to ${toDate}`
          : "";
    }
    const ComparisonDateJson = {
      ComparisonValue: comparisonValue,
      ComparisonDateType: comparisonType,
      FromDate: fromDate,
      ToDate: toDate,
      DisplayComparisonTypeDate: displayComparisonDate,
    };
    dispatch(loadComparisonDateData(ComparisonDateJson));
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
    fontSize: "18px",
    paddingLeft: "5px",
    marginBottom: "20px",
  };

  const ComparisonDateOptions = () => {
    return (
      <>
        <RadioGroup
          className="dk-pd-bt-15"
          onChange={(e) => {
            handleChangeRadioComparison(e);
          }}
          checked={true}
          value={getComparisonValue}
        >
          <Radio style={radioStyle} value={0}>
            <IntlMessages id="components.reporting.comparisondateselectfilter.nocomparison" />
          </Radio>
          <Radio style={radioStyle} value={1}>
            <IntlMessages id="components.reporting.comparisondateselectfilter.samedateinprevyear" />
            {/* <div className="dk-radio-description">{getSameDatePreviousYear}</div> */}
            <div className="dk-radio-description">{getDisplayDate}</div>
          </Radio>
          {/* <Radio style={radioStyle} value={3}>
            <IntlMessages id="components.reporting.comparisondateselectfilter.sameperiodinprevyear" />
            <div className="dk-radio-description">
              <IntlMessages id="components.reporting.comparisondateselectfilter.matchingtoweekdays" />
            </div>
          </Radio> */}
        </RadioGroup>
      </>
    );
  };

  const dateComparisonContent = (
    <>
      <ComparisonDateOptions />
      <div className="dk-specific-date dk-pt3 dk-pb3 custom-mg-top-10-i">
        <span className={"dk-comparison-date-span"}>
          {/* {getComparisonDateJson &&
            getComparisonDateJson != undefined &&
            getComparisonValue != 1
            ? getComparisonDateJson.DisplayComparisonTypeDate
            : ""} */}
          {!isEmptyObject(getReduxComparisonDateData) &&
          getReduxComparisonDateData.DisplayComparisonTypeDate
            ? getReduxComparisonDateData.DisplayComparisonTypeDate
            : ""}
        </span>
        <Button
          className="mr-2"
          type="primary"
          onClick={() => handleClickDateApply()}
        >
          {" "}
          <IntlMessages id="components.reporting.apply" />
        </Button>
      </div>
    </>
  );

  return (
    <>
      <Popover
        placement="bottom"
        content={dateComparisonContent}
        // content={""}
        trigger="click"
        onVisibleChange={() => {
          setIsDateComparisonPopoverVisible(!getIsDateComparisonPopoverVisible);
        }}
        visible={getIsDateComparisonPopoverVisible}
      >
        <Form.Item
          className="ant-form-item-label-custom"
          name={"SpecifiedDateRange"}
          label={<IntlMessages id="components.reporting.comparison" />}
        >
          <Button
            size="large"
            onClick={() => {
              setIsDateComparisonPopoverVisible(true);
            }}
            style={{ width: "100%" }}
          >
            <div className="date-range-container">
              <p className="custom-font-size-18 custom-inline dk-mg-0">
                {/* {!isEmptyObject(getReduxComparisonDateData) &&
                  getReduxComparisonDateData.DisplayComparisonTypeDate ?
                  getReduxComparisonDateData.DisplayComparisonTypeDate :
                  <IntlMessages id="components.reporting.comparisondateselectfilter.nocomparison" />
                } */}
                {getComparisonValue == 1 ? (
                  getDisplayDate
                ) : (
                  <IntlMessages id="components.reporting.comparisondateselectfilter.nocomparison" />
                )}
              </p>
              <i className="icon icon-chevron-down dk-mg-left-3" />
            </div>
          </Button>
        </Form.Item>
      </Popover>
    </>
  );
};

export default ComparisonDateSelectFilter;
